import { type AxiosResponse, AxiosError } from 'axios';

import { camelToSnakeCase } from '@/lib/convert-code-style';

import { axiosErrors, customRes, type ApiResponse, type CustomAxiosResponse } from './AxiosResponse';
import { SUCCESS, SUCCESS_201, SUCCESS_206 } from '@/lib/common/name-space';

export interface EndpointPayload {
  path: string;
  body?: any;
  apiUrl?: string;
  skipConvert?: boolean;
}

export const sendRequest = async (
  payload: EndpointPayload,
  functionName: string,
  axiosApi: any,
): Promise<CustomAxiosResponse> => {
  try {
    const body = payload?.skipConvert
      ? payload?.body || null
      : Array.isArray(payload?.body)
        ? payload.body.map((item) => camelToSnakeCase(item)) // 배열이면 각 요소에 변환 적용
        : camelToSnakeCase(payload?.body) || null; // 객체면 변환 적용
    const response: AxiosResponse<ApiResponse> = await axiosApi({
      path: payload.path,
      body,
      ...(payload.apiUrl && { apiUrl: payload.apiUrl }),
    });
    if (
      (response.data?.statusCode &&
        response.data.statusCode !== SUCCESS &&
        response.data.statusCode !== SUCCESS_201 &&
        response.data.statusCode !== SUCCESS_206) ||
      (response.status && response.status !== SUCCESS && response.status !== SUCCESS_201)
    ) {
      const mockAxiosError = new AxiosError(
        response.data?.message || '',
        'ERR_BAD_RESPONSE',
        response.config,
        response.request,
        {
          data: response.data,
          status: response.status,
          statusText: response.statusText,
          headers: response.headers,
          config: response.config,
        },
      );
      return await axiosErrors(mockAxiosError, functionName);
    }
    const re: CustomAxiosResponse = customRes(response);
    return re;
  } catch (e) {
    return await axiosErrors(e, functionName);
  }
};
